import { FaCapsules, FaUserMd, FaBed, FaIndustry, FaUserTie, FaProcedures, FaPlusCircle } from 'react-icons/fa';
import { Link } from "react-router-dom";
import { fetchRecentUsersAsync } from "../../services/user/UserSlice"
import { useEffect, useState } from 'react';
import { AsyncThunk, ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';
import { RecentUser, User } from '../../services/user/User.type';
import { useAppDispatch } from '../../../redux/hooks';
import Tooltip from '@mui/material/Tooltip'; // Using Material-UI Tooltip for better styling and behavior.


const Dashboard: React.FC = () => {

  const quickLinks = [    
    { 
      Name: 'Patients', 
      Path: "/users", 
      Icon: (
        <div 
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', // Center the icons horizontally
            gap: '10px', // Add spacing between icons
            width: '100%', // Ensure the container takes full width
            textAlign: 'center' // Align text inside the parent
          }}
        >
          <FaProcedures />
          <FaPlusCircle title="Add New Patient" />
        </div>
      ) ,
      Tooltip: "Add New Patient" 
    },    
    { Name: 'Medicine', Path: "medicines", Icon: <FaCapsules /> },
    { Name: 'Staff', Path: "staffs", Icon: <FaUserTie /> },
    { Name: 'Doctors', Path: "doctors", Icon: <FaUserMd /> },
    { Name: 'Rooms', Path: "rooms", Icon: <FaBed /> },
    { Name: 'Vendors', Path: "vendors", Icon: <FaIndustry /> }
  ];

    const [recentPatients, setRecentPatients] = useState<RecentUser[]>([]);

    const dispatch = useAppDispatch(); 
  
    useEffect(() => {
      const loadRecentPatients = async () => {
        try {
          await fetchRecentPatients();
        } catch (error) {
          console.error("Failed to fetch recent patients", error);
        }
      };
  
      loadRecentPatients();
    }, []);
  
    const fetchRecentPatients = async () => {
      try {
        const recentStudentCount:number = 10;
        const patientData = await dispatch(fetchRecentUsersAsync(recentStudentCount)).unwrap();
        setRecentPatients(patientData);        
      } catch (error) {
        console.error("Failed to fetch users:", error);
      }
    };
    
  
  return (
    <div>
      <h3>Home page & Quick Links</h3>

      <p className="floatleft width40">
        {recentPatients.map(item => (
         <div className="card floatleft" key={item?.patientId}>
         <a
             href={`/patient-care-ui?patientId=${encodeURIComponent(item?.id)}&name=${encodeURIComponent(item?.personalDetails?.firstName + " " + item?.personalDetails?.lastName)}&bloodGroup=${encodeURIComponent(item?.personalDetails?.bloodGroup)}&dateOfBirth=${encodeURIComponent(item?.personalDetails?.dateOfBirth)}`}
         >
             <img src="https://www.w3schools.com/howto/img_avatar.png" alt="Avatar" className="width100" />
         </a>
         <div className="container">
             <p><b>{item?.personalDetails?.firstName + " " + item?.personalDetails?.lastName}</b></p>
             <p><b>{item?.personalDetails?.bloodGroup || "Not Found"}</b></p>
             <p><b>{item?.personalDetails?.dateOfBirth || "Not Found"}</b></p>
             <p>{item?.personalDetails?.gender || "Not Found"}</p> 
         </div>
     </div>
        ))}
      </p>

      <p className="floatright width40">
      {quickLinks.map(item => (
        <Tooltip key={item.Name} title={item.Tooltip} arrow>
          <Link to={item.Path} className="card floatleft quicklink" style={{ textDecoration: 'none', color: 'white' }}>

            <div className="quicklinkicon">{item.Icon}</div>
            <div className="container">
              <h4><b>{item.Name}</b></h4>
            </div>
          </Link>
        </Tooltip>
      ))}
    </p>

    </div>
  );
};

export default Dashboard;
function dispatch(fetchUsersAsync: AsyncThunk<User[], void, { state?: unknown; dispatch?: ThunkDispatch<unknown, unknown, UnknownAction>; extra?: unknown; rejectValue?: unknown; serializedErrorType?: unknown; pendingMeta?: unknown; fulfilledMeta?: unknown; rejectedMeta?: unknown; }>) {
  throw new Error('Function not implemented.');
}

